import { Layout } from 'antd'
import { styled } from 'styled-components'

export const StyledLayout = styled(Layout)`
  width: 100%;
  min-height: 100vh;
`

export const StyledContent = styled(Layout.Content)`
  padding: 64px 48px 0;
`
